import Client from 'config/axios';

export interface AgentData {
  name: string;
  lastName: string;
  email: string;
  status: string;
  companyIds: number[];
}

export const createAgent = async (
  token: string,
  agent: AgentData,
  companyIds: any
) => {
  try {
    const idsCompanies = companyIds.map((company: any) =>
      Number(company.value)
    );
    const agentData: AgentData = {
      ...agent,
      status: 'ACTIVE',
      companyIds: idsCompanies
    };

    const { data } = await Client.post('agent', agentData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return { data: data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
